import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { eventFindInPath } from '@fi-shared/utils';

@Directive({
    selector: '[fiDisableLinks]',
    standalone: false,
})
export class FiDisableLinksDirective implements AfterViewInit {
    constructor(private elementRef: ElementRef) {}

    ngAfterViewInit() {
        this.elementRef.nativeElement.addEventListener(
            'click',
            ($event: Event) => {
                if (eventFindInPath($event, 'a')) {
                    $event.preventDefault();
                }
            },
            true,
        );
    }
}
